/* eslint-disable react/display-name */
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import {
  DeleteOutlined,
  DownloadOutlined,
  EditOutlined,
  FileExcelFilled,
  InfoCircleFilled,
  PlusOutlined,
  SearchOutlined,
} from '@ant-design/icons'
import { Col, Row, Space, Input, Image, Switch, Menu, Dropdown, Tag, Tooltip } from 'antd'
import { connect, useDispatch } from 'react-redux'
import { RootState } from 'Store'
import {
  ListReq,
  DeleteReq,
  UpdateProductStatusReq,
  ProductOptions,
  ProductImportVerify,
} from 'Store/product/types'
import {
  selectActionEvent,
  selectLastProductImport,
  selectList,
  selectListEvent,
} from 'Store/product/selector'
import { selectCurrentUser } from 'Store/user/selector'
import { productListAPI, deleteProductAPI, updateProductStatusAPI } from 'Store/product/api'
import {
  getDeliveryMenuSelect,
  getProductRequestStatus,
  getProductStatus,
  getRequestString,
  numberWithComma,
} from 'helpers/format'
import { Data as UomData } from 'Store/uom/types'
import { AppTutorial, StatusTag } from 'Components/utilities'
import { TableListPage } from 'Components/common/Table'
import { ActionButton, PrimaryButton } from 'Components/button'
import HomePageLayout from 'Pages/Layout/PageLayout'
import Detail from './detail'
import ImportProduct from './import'
import ImportProductFromFile from './import-file'
import { ConfirmDailog, EventModal } from 'Components/modal'
import { appConfig, themeConfig } from 'config'
import { clearEventAction } from 'Store/product/actions'
import {
  ImageFallback,
  menuProductMaterialType,
  menuProductRequestStatus,
  menuProductStatus,
  menuShipingType,
  ProductCreatedBy,
  ProductRequestStatus,
  ProductStatus,
} from 'helpers/constanst'
import { Pagination } from 'Components/Pagination'
import { categoriesListAPI } from 'Store/categories/api'
import { uomListAPI } from 'Store/uom/api'
import { manufactuerListAPI } from 'Store/manufactuer/api'
import { getMasterMerchantsAPI } from 'Store/merchants/api'
import { selectList as selectCateList } from 'Store/categories/selector'
import { selectList as selectUomList } from 'Store/uom/selector'
import { selectList as selectManufactuerList } from 'Store/manufactuer/selector'
import { selectMasterMerchant } from 'Store/merchants/selector'
import Category from 'Components/form/Category'
import { Data } from 'Store/product/types'
import { Tabs } from 'antd'
import { SelectItem } from 'Components/form'
import theme, { MyTheme } from 'Components/common/Theme'
import { getDeliveryCostAPI } from 'Store/delivery-cost/api'
import { selectDatas as selectDeliveryDatas } from 'Store/delivery-cost/selector'
import { selectIsHasPackageC, selectIsPackageC } from 'Store/pos/selector'
import AdjustPrice from './adjust-price'
import AdjustMaterial from './adjust-material'
import { getStaffPermission } from 'helpers/account'
import ConfirmImportProduct from 'Components/modal/ConfirmImportProduct'
import { TutoriaProductPage } from 'helpers/tutorials'
import { ProductSample } from 'helpers/sample-data'
import ProductMultiUoms from './components/ProductMultiUoms'
const { TabPane } = Tabs

type Props = {} & ReduxProps

const Product: React.FunctionComponent<Props> = props => {
  const {
    currentUser,
    listEvent,
    dataList,
    event,
    categories,
    uoms,
    manufactuers,
    masterMerchant,
    deliveryCost,
    isPackageC,
    isHasPackage,
    lastProductImport,
  } = props
  const isSupperAdmin = currentUser?.activeMerchant?.id === parseInt(appConfig.merchantID || '')
  const dispatch = useDispatch()
  const [searchKeyword, setSearchKeyword] = useState('')
  const [drawer, setDrawer] = useState(false)
  const [priceDrawer, setPriceDrawer] = useState(false)
  const [materialDrawer, setMaterialDrawer] = useState(false)
  const [importDrawer, setImportDrawer] = useState(false)
  const [selectedID, setSelectedID] = useState(0)
  const [activeTab, setActiveTab] = useState(ProductCreatedBy.ADD as string)
  const [pageMode, setPageMode] = useState('create' as 'create' | 'edit' | 'deleted' | 'updateStatus')
  const [confirmDeleteDialog, setConfirmDeleteDialog] = useState(false)
  const [importDailog, setImportDailog] = useState(false)
  const [importFileDrawer, setImportFileDrawer] = useState(false)
  const [productFileData, setProductFileData] = useState([] as ProductImportVerify[])
  const permission = getStaffPermission()
  const hasEditPermission = permission && permission.includes('/product-update-price')
  const hasDeletePermission = permission && permission.includes('delete-products')
  const hasManageBomPermission = permission && permission.includes('manage-bom')
  const hasImportFileProductPermission = permission && permission.includes('import-file-product')
  const enableProductOnline = themeConfig?.component?.elementOnlineProduct
  const isFranchise = currentUser?.activeMerchant?.is_fc === true
  //const hasEditPermission = true

  // tutorial
  const [showTutorial, setShowTutorial] = useState(false as boolean)
  const steps = TutoriaProductPage.list.steps
  const enableTutorial = TutoriaProductPage.list.enable

  const [filter, setFilter] = useState({
    keyword: '',
    categories: [] as number[],
    request_status: '' as ProductRequestStatus,
    status: '' as ProductStatus,
    shipping_type: '',
    distance_delivery_config_id: 0,
    sort: '',
    order_by: '',
    status_pos: '',
    bom: 0,
  })
  const [pagination, setPagination] = useState({
    Page: 1,
    RowPerPage: 10,
  })

  const datas = showTutorial ? ProductSample : dataList.data
  const meta = dataList.meta
  console.log('datas', datas)

  const onGetMasterData = (): void => {
    const merchant_id = currentUser?.activeMerchant?.id || 0
    const token = currentUser.accessToken
    dispatch(
      categoriesListAPI(
        {
          merchant_id,
          include_child: true,
        },
        token,
      ),
    )

    dispatch(
      manufactuerListAPI(
        {
          merchant_id,
        },
        token,
      ),
    )

    dispatch(
      uomListAPI(
        {
          merchant_id,
        },
        token,
      ),
    )
    dispatch(getMasterMerchantsAPI({}, token))

    dispatch(
      getDeliveryCostAPI(
        {
          type: 'distance',
        },
        token,
        currentUser?.activeMerchant?.uuid || '',
      ),
    )
  }

  const onGetDataList = (): void => {
    const req: ListReq = {
      merchant_id: currentUser?.activeMerchant?.id || 0,
      page: pagination.Page,
      per_page: pagination.RowPerPage,
      keyword: filter.keyword?.trim() || '',
      group_id: (filter?.categories && filter?.categories[0]) || 0,
      create_type: isSupperAdmin ? '' : activeTab,
      request_status: filter.request_status || '',
      status: filter?.status || '',
      status_pos: filter?.status_pos || '',
      is_admin: true,
      shipping_types: filter.shipping_type?.trim() || '',
      order_by: filter.order_by,
      sort: filter.sort,
    }

    if (filter.bom) {
      req.bom = filter.bom === 100 ? 0 : filter.bom
    }

    if (filter.shipping_type === 'shop_delivery' || filter.shipping_type === 'special_delivery') {
      req.distance_delivery_config_id = filter.distance_delivery_config_id || undefined
    } else {
      //onFilter('distance_delivery_config_id', 0)
    }

    if (filter?.categories && filter?.categories[1]) {
      req.category_id = filter?.categories[1]
    }
    if (filter?.categories && filter?.categories[2]) {
      req.sub_category_id = filter?.categories[2]
    }
    dispatch(productListAPI(req, currentUser.accessToken))
  }

  const onDelete = (id: number): void => {
    const req: DeleteReq = {
      id,
    }
    dispatch(deleteProductAPI(req, currentUser.accessToken))
  }

  const onUpdateProductStatus = (id: number, status: ProductStatus): void => {
    const req: UpdateProductStatusReq = {
      id,
      status,
    }
    dispatch(updateProductStatusAPI(req, currentUser.accessToken))
  }

  const onUpdateTerminalStatus = (id: number, status: ProductStatus): void => {
    const req: UpdateProductStatusReq = {
      id,
      status,
      channel: 'pos',
    }
    dispatch(updateProductStatusAPI(req, currentUser.accessToken))
  }

  const onImportFile = (file: any, productData: ProductImportVerify[]): void => {
    setProductFileData(productData)
    setImportDailog(false)
    onOpenImportFileDrawer()
  }

  const onExportBarcode = () => {
    const req: any = {
      mid: currentUser?.activeMerchant?.id || '',
      nopic: 1,
      group_id: filter?.categories[0] || 0,
      category_id: (filter?.categories && filter?.categories[1]) || 0,
      sub_category_id: filter?.categories[2] || 0,
    }
    const endPoint = appConfig.backofficeEndpoint + `/backend/api/v1/test-xxx?${getRequestString(req)}`
    window.open(endPoint, '_blank')
  }

  useEffect(() => {
    onGetMasterData()
    setProductFileData([])
  }, [])

  // useEffect(() => {
  //   if (isPackageC) {
  //     onGetConfig()
  //   }
  // }, [isPackageC])

  useEffect(() => {
    if (currentUser?.accessToken && !listEvent.IsLoading) {
      onGetDataList()
    }
  }, [pagination, activeTab])

  useEffect(() => {
    if (pagination.Page === 1) return
    pagination.Page = 1
    pagination.RowPerPage = 10
    setPagination({ ...pagination })
  }, [])

  const onFilter = (key: string, val: any) => {
    setFilter({
      ...filter,
      [key]: val,
    })
  }

  const onSort = (order_by: string, sort: string) => {
    setFilter({
      ...filter,
      sort,
      order_by,
    })
  }

  useEffect(() => {
    const timer1 = setTimeout(() => onFilter('keyword', searchKeyword), 1000)
    return () => {
      clearTimeout(timer1)
    }
  }, [searchKeyword])

  useEffect(() => {
    pagination.Page = 1
    setPagination({ ...pagination })
  }, [filter])

  const onOpenDrawer = () => {
    setDrawer(true)
  }

  const onCloseDrawer = () => {
    setDrawer(false)
    setPriceDrawer(false)
  }

  const onOpenPriceDrawer = () => {
    setPriceDrawer(true)
  }

  const onOpenImportDrawer = () => {
    setImportDrawer(true)
  }

  const onCloseImportDrawer = () => {
    setImportDrawer(false)
  }

  const onOpenImportFileDrawer = () => {
    setImportFileDrawer(true)
  }

  const onCloseImportFileDrawer = () => {
    setImportFileDrawer(false)
  }
  const onCloseMaterialDrawer = () => {
    setMaterialDrawer(false)
  }

  const onClickDelete = (id: number) => {
    setPageMode('deleted')
    setSelectedID(id)
    onOpenConfirmDelete()
  }

  const onConfirmDelete = () => {
    onDelete(selectedID)
    onCloseConfirmDelete()
  }

  const onOpenConfirmDelete = () => {
    setConfirmDeleteDialog(true)
  }

  const onCloseConfirmDelete = () => {
    setConfirmDeleteDialog(false)
  }

  const onClickCreate = () => {
    setPageMode('create')
    setSelectedID(0)
    onOpenDrawer()
  }

  const onClickEdit = (id: number, isAdjustPrice: boolean = false) => {
    setPageMode('edit')
    setSelectedID(id)
    if (isAdjustPrice) {
      onOpenPriceDrawer()
    } else {
      onOpenDrawer()
    }
  }

  const onClickManageMaterial = (id: number) => {
    setPageMode('edit')
    setSelectedID(id)
    setMaterialDrawer(true)
  }

  const onClickImportFile = () => {
    setProductFileData([])
    setImportDailog(true)
  }

  const onSuccess = () => {
    onCloseDrawer()
    onCloseImportDrawer()
    onCloseImportFileDrawer()
    onCloseMaterialDrawer()
    onGetDataList()
  }

  const clearEvent = (): void => {
    dispatch(clearEventAction())
  }

  const onDeleteSuccess = (): void => {
    clearEvent()
    onGetDataList()
  }

  const onChangeTab = (key: string): void => {
    setActiveTab(key)
    pagination.Page = 1
    pagination.RowPerPage = 10
    setPagination({ ...pagination })
  }

  const renderStatus = (status: ProductStatus) => (
    <StatusTag isPass={status === ProductStatus.ACTIVE} text={getProductStatus(status)} />
  )

  const renderRequestStatus = (status: ProductRequestStatus) => {
    const request = getProductRequestStatus(status)
    return <StatusTag isPass={true} color={request.color} text={request.text} />
  }

  const renderCategory = (group: any, record: Data) =>
    `${group?.name || ''} / ${record.category?.name || ''} / ${record.sub_category?.name || ''}`

  const renderImage = (img: string[]) => (
    <ThumbImage src={appConfig.assetCdnEndpoint + `${img && img[0]}`} fallback={ImageFallback} />
  )

  const renderProductStatus = (status: ProductStatus, record: Data) => {
    if (!enableProductOnline) return <span />
    return (
      <Switch
        loading={event.IsLoading && pageMode !== 'deleted'}
        checked={status === ProductStatus.ACTIVE}
        onChange={(val: boolean) => {
          setPageMode('updateStatus')
          const status = val ? ProductStatus.ACTIVE : ProductStatus.INACTIVE
          onUpdateProductStatus(record.id, status)
        }}
        checkedChildren={<SwitchText>เปิดใช้งาน</SwitchText>}
        unCheckedChildren={<SwitchText>ปิดใช้งาน</SwitchText>}
      />
    )
  }

  const renderTerminalStatus = (status: ProductStatus, record: Data) => {
    if (!isHasPackage) return
    return (
      <Switch
        loading={event.IsLoading && pageMode !== 'deleted'}
        checked={status === ProductStatus.ACTIVE}
        onChange={(val: boolean) => {
          setPageMode('updateStatus')
          const status = val ? ProductStatus.ACTIVE : ProductStatus.INACTIVE
          onUpdateTerminalStatus(record.id, status)
        }}
        checkedChildren={<SwitchText>เปิดใช้งาน</SwitchText>}
        unCheckedChildren={<SwitchText>ปิดใช้งาน</SwitchText>}
        className="ttr-status"
      />
    )
  }

  const renderProductPrices = (product: ProductOptions[]) => {
    return numberWithComma((product && product.length > 0 && product[0].price) || 0, true)
  }

  const renderProductTitle = (title: string, product: Data) => {
    return (
      <Space direction="vertical" size={'small'}>
        <span>{title}</span>
        {product?.bom === 1 && (
          <Tooltip
            title={
              <span>
                คุณสามาถจัดการส่วนประกอบของสินค้าได้ โดยการกดที่ปุ่ม แก้ไข <EditOutlined /> และเลือกเมนู
                &quot;จัดการส่วนประกอบสินค้า&quot;
              </span>
            }
            placement="top"
            arrowPointAtCenter
          >
            <Tag icon={<InfoCircleFilled />} color={theme.colors.primary} style={{ cursor: 'pointer' }}>
              สินค้ามีส่วนประกอบ
            </Tag>
          </Tooltip>
        )}
      </Space>
    )
  }

  const renderProductStock = (product: ProductOptions[], record: Data) => {
    const stockCount =
      ((product && product.length > 0 && product[0].quantity) || 0) +
      ((product && product.length > 0 && product[0]?.quantity_offline) || 0)
    const stock = numberWithComma(stockCount)
    return stockCount < 10 ? (
      <StockMin>
        <Space size="small">
          {stock} {renderProductUom(record?.uom?.name || '', record)}
        </Space>
      </StockMin>
    ) : (
      <span>
        <Space size="small">
          {stock} {renderProductUom(record?.uom?.name || '', record)}
        </Space>
      </span>
    )
  }

  const renderProductUom = (uom: string, product: Data) => {
    const firstOption = product?.product_options[0]
    const uoms = firstOption?.uoms || []

    return <ProductMultiUoms uoms={uoms} showMaster={true} priceKey="price" priceTitle="ราคา" />
  }

  const menu = (product: any) => {
    return (
      <Menu>
        {/* {!isFranchise && <Menu.Item onClick={() => onClickEdit(product.id)}>แก้ไขข้อมูลสินค้า</Menu.Item>} */}
        <Menu.Item onClick={() => onClickEdit(product.id)}>แก้ไขข้อมูลสินค้า</Menu.Item>
        {hasEditPermission && (
          <Menu.Item
            onClick={() => onClickEdit(product.id, true)}
            disabled={product?.request_status === ProductRequestStatus.PENDING}
          >
            จัดการราคาสินค้าโดยไม่ผ่านการอนุมัติ
          </Menu.Item>
        )}
        {hasManageBomPermission && product?.bom === 1 && (
          <Menu.Item onClick={() => onClickManageMaterial(product.id)}>จัดการส่วนประกอบสินค้า</Menu.Item>
        )}
      </Menu>
    )
  }

  const renderActionButton = (id: number, record: any) => {
    return (
      <Space size="middle" className="ttr-action">
        {hasEditPermission || hasManageBomPermission ? (
          <Dropdown key="more" overlay={menu(record)} trigger={['click', 'hover']}>
            <ActionButton text="" icon={<EditOutlined />} label="แก้ไข" action="edit" onClick={() => {}} />
          </Dropdown>
        ) : (
          <ActionButton
            text=""
            icon={<EditOutlined />}
            label="แก้ไข"
            action="edit"
            onClick={() => onClickEdit(record.id)}
          />
        )}
        {!isFranchise && hasDeletePermission && (
          <ActionButton
            text=""
            icon={<DeleteOutlined />}
            label="ลบ"
            action="deleted"
            onClick={() => onClickDelete(record.id)}
          />
        )}
      </Space>
    )
  }

  const columnsBaady = [
    {
      title: 'รูปภาพสินค้า',
      dataIndex: 'photos',
      key: 'photos',
      render: renderImage,
      width: '120px',
    },
    // {
    //   title: 'ID',
    //   dataIndex: 'id',
    //   key: 'id',
    // },
    {
      title: 'รหัสสินค้า',
      dataIndex: 'code',
      key: 'code',
      sorter: true,
    },
    {
      title: 'ชื่อสินค้า',
      dataIndex: 'title',
      key: 'title',
      width: '200px',
      sorter: true,
      render: renderProductTitle,
    },
    {
      title: 'ราคา',
      dataIndex: 'product_options',
      key: 'product_options_price',
      render: renderProductPrices,
    },
    {
      title: 'สต๊อก',
      dataIndex: 'product_options',
      key: 'product_options_stock',
      render: renderProductStock,
      width: '120px',
    },
    // {
    //   title: 'หน่วย',
    //   dataIndex: 'uom',
    //   key: 'uom',
    //   render: renderProductUom,
    // },
    {
      title: 'หมวดหมู่สินค้า',
      dataIndex: 'group',
      key: 'group',
      width: '200px',
      render: renderCategory,
    },
    {
      title: enableProductOnline ? (isHasPackage ? 'สถานะสินค้าบนออนไลน์' : 'สถานะสินค้า') : '',
      dataIndex: 'status',
      key: 'status',
      render: renderProductStatus,
      width: enableProductOnline ? '120px' : '0px',
      align: 'center',
    },
    {
      title: isHasPackage ? 'สถานะสินค้าบน Terminal' : '',
      dataIndex: 'status_pos',
      key: 'status_pos',
      render: renderTerminalStatus,
      width: isHasPackage ? '120px' : '0px',
      align: 'center',
    },
    // {
    //   title: 'สถานะสินค้า',
    //   dataIndex: 'status',
    //   key: 'status',
    //   render: renderStatus,
    //   width: '100px',
    // },
    {
      title: '',
      dataIndex: 'action',
      key: 'action',
      render: renderActionButton,
    },
  ]

  const columnsOtherMerchant = [
    {
      title: 'รูปภาพสินค้า',
      dataIndex: 'photos',
      key: 'photos',
      render: renderImage,
      width: '100px',
    },
    // {
    //   title: 'ID',
    //   dataIndex: 'id',
    //   key: 'id',
    // },
    {
      title: 'รหัสสินค้า',
      dataIndex: 'code',
      key: 'code',
      sorter: true,
    },
    {
      title: 'ชื่อสินค้า',
      dataIndex: 'title',
      key: 'title',
      width: '180px',
      sorter: true,
      render: renderProductTitle,
    },
    {
      title: 'ราคา',
      dataIndex: 'product_options',
      key: 'product_options_price',
      render: renderProductPrices,
    },
    {
      title: 'สต๊อก',
      dataIndex: 'product_options',
      key: 'product_options_stock',
      render: renderProductStock,
      width: '120px',
    },
    // {
    //   title: 'หน่วย',
    //   dataIndex: 'uom',
    //   key: 'uom',
    //   render: renderProductUom,
    // },
    {
      title: 'หมวดหมู่สินค้า',
      dataIndex: 'group',
      key: 'group',
      width: '150px',
      render: renderCategory,
    },
    {
      title: enableProductOnline ? (isHasPackage ? 'สถานะสินค้าบนออนไลน์' : 'สถานะสินค้า') : '',
      dataIndex: 'status',
      key: 'status',
      render: renderProductStatus,
      width: enableProductOnline ? '120px' : '0px',
      align: 'center',
    },
    {
      title: isHasPackage ? 'สถานะสินค้าบน Terminal' : '',
      dataIndex: 'status_pos',
      key: 'status_pos',
      render: renderTerminalStatus,
      width: isHasPackage ? '120px' : '0px',
      align: 'center',
    },
    // {
    //   title: 'สถานะสินค้า',
    //   dataIndex: 'status',
    //   key: 'status',
    //   render: renderStatus,
    //   width: '100px',
    // },
    {
      title: enableProductOnline ? 'สถานะคำขอแก้ไขล่าสุด' : '',
      dataIndex: 'request_status',
      key: 'request_status',
      render: renderRequestStatus,
      width: enableProductOnline ? '100px' : '0px',
      align: 'center',
    },
    {
      title: '',
      dataIndex: 'action',
      key: 'action',
      render: renderActionButton,
    },
  ]

  const columns = isSupperAdmin ? columnsBaady : columnsOtherMerchant

  const DetailDrawer = (
    <Detail
      mode={pageMode}
      id={selectedID}
      visible={drawer}
      onCloseDrawer={onCloseDrawer}
      onSuccess={onSuccess}
      masterData={{
        categories: categories.data,
        manufacturers: manufactuers.data,
        uoms: uoms.data,
      }}
    />
  )

  const AdjustPriceDrawer = (
    <AdjustPrice
      mode={pageMode}
      id={selectedID}
      visible={priceDrawer}
      onCloseDrawer={onCloseDrawer}
      onSuccess={onSuccess}
    />
  )

  const AdjustMaterialDrawer = (
    <AdjustMaterial
      mode={pageMode}
      id={selectedID}
      visible={materialDrawer}
      onCloseDrawer={() => setMaterialDrawer(false)}
      onSuccess={onSuccess}
    />
  )

  const ImportDrawer = (
    <ImportProduct
      visible={importDrawer}
      onCloseDrawer={onCloseImportDrawer}
      onSuccess={onSuccess}
      masterMerchant={masterMerchant}
    />
  )

  const ConfirmDeleteModal = (
    <ConfirmDailog
      isShow={confirmDeleteDialog}
      handleOk={onConfirmDelete}
      handleCancel={onCloseConfirmDelete}
    />
  )

  const LoadingModal = (
    <EventModal
      event={[event]}
      enable={pageMode === 'deleted' || pageMode === 'updateStatus'}
      successCalback={onDeleteSuccess}
      errorCalback={clearEvent}
    />
  )

  console.log('categories.data', categories.data)

  const mdSpan = 6
  const FilterContent = (
    <FilterWrapper className="ttr-filter">
      <Row justify="space-between" align="bottom">
        <MyCol span={24}>
          <Row justify="start" gutter={[16, 16]}>
            <Col md={mdSpan} xs={24}>
              <SearchInput
                placeholder="ค้นหาชื่อ,รหัสสินค้า"
                prefix={<SearchOutlined />}
                allowClear
                value={searchKeyword}
                onChange={(evt: any): void => setSearchKeyword(evt.target.value)}
              />
            </Col>
            <Col md={mdSpan} xs={24}>
              <Category
                placeholder="ค้นหาชื่อหมวดหมู่สินค้า"
                data={filter.categories}
                categories={categories.data}
                handleChange={(val: []) => onFilter('categories', val)}
              />
            </Col>
            {enableProductOnline && (
              <Col md={mdSpan} xs={24}>
                <SelectItem
                  name={'status'}
                  label={''}
                  isRequired={true}
                  value={filter.status}
                  menu={menuProductStatus}
                  placeHolder={'สถานะสินค้าบนออนไลน์'}
                  onChange={(val: string): any => onFilter('status', val)}
                />
              </Col>
            )}

            {isPackageC && (
              <Col md={mdSpan} xs={24}>
                <SelectItem
                  name={'status_pos'}
                  label={''}
                  isRequired={true}
                  value={filter.status_pos}
                  menu={menuProductStatus}
                  placeHolder={'สถานะสินค้าบน Terminal '}
                  onChange={(val: string): any => onFilter('status_pos', val)}
                />
              </Col>
            )}

            {!isSupperAdmin && (
              <Col md={mdSpan} xs={24}>
                <SelectItem
                  name={'request_status'}
                  label={''}
                  isRequired={true}
                  value={filter.request_status}
                  menu={menuProductRequestStatus}
                  placeHolder={'สถานะคำขอแก้ไข'}
                  onChange={(val: string): any => onFilter('request_status', val)}
                />
              </Col>
            )}
            <Col md={mdSpan} xs={24}>
              <SelectItem
                name={'shipping_type'}
                label={''}
                isRequired={true}
                value={filter.shipping_type}
                menu={menuShipingType}
                placeHolder={'ช่องทางการจัดส่ง'}
                onChange={(val: string): any => onFilter('shipping_type', val)}
              />
            </Col>
            {(filter.shipping_type === 'shop_delivery' || filter.shipping_type === 'special_delivery') && (
              <Col md={mdSpan} xs={24}>
                <SelectItem
                  name={'distance_delivery_config_id'}
                  label={''}
                  isRequired={true}
                  value={filter.distance_delivery_config_id}
                  menu={getDeliveryMenuSelect(deliveryCost, 'title', 'id')}
                  placeHolder={'ระยะทางจัดส่งสินค้า'}
                  onChange={(val: string): any => onFilter('distance_delivery_config_id', parseInt(val))}
                />
              </Col>
            )}
            {isPackageC && (
              <Col md={mdSpan} xs={24}>
                <SelectItem
                  name={'bom'}
                  label={''}
                  isRequired={true}
                  value={filter.bom}
                  menu={menuProductMaterialType}
                  placeHolder={'ประเภทสินค้า'}
                  onChange={(val: any): any => onFilter('bom', val)}
                />
              </Col>
            )}

            {/* <Col>
              <PrimaryButton text="ค้นหา" btnType="Cancel" onClick={onGetDataList} />
            </Col> */}
            {/* <Col>
              <PrimaryButton
                key={ProductCreatedBy.ADD}
                btnType="Cancel"
                text="Barcode สินค้า"
                icon={<BarcodeOutlined />}
                onClick={onExportBarcode}
              />
            </Col> */}
          </Row>
        </MyCol>
      </Row>
    </FilterWrapper>
  )

  const PaginationContent = (
    <Pagination
      key={activeTab}
      currentPage={pagination.Page}
      totalRows={meta?.totalCount || 0}
      perPage={pagination.RowPerPage}
      onClickPage={(page: number) => {
        pagination.Page = page
        setPagination({ ...pagination })
      }}
      onChangeNumber={(number: number) => {
        pagination.RowPerPage = number
        setPagination({ ...pagination })
      }}
      className="ttr-pagination"
    />
  )

  const checkIsNewImport = (productId: number) => {
    const findOrder = lastProductImport && lastProductImport?.find(item => item?.id === productId)
    return findOrder ? true : false
  }

  const table = (
    <TableListPage
      columns={columns}
      datas={datas}
      isLoading={listEvent.IsLoading}
      paginationContent={PaginationContent}
      size="small"
      onSort={(field: string, order: string) => {
        onSort(field, order)
      }}
      rowClassName={(record: ProductImportVerify) => (checkIsNewImport(record.id) ? 'row-new' : '')}
      className="ttr-datas"
      scrollX={1100}
    />
  )

  const content = (
    <>
      {FilterContent}
      {table}
    </>
  )

  const getTab = () => {
    return (
      <Tabs defaultActiveKey={ProductCreatedBy.ADD} onChange={onChangeTab} type="line">
        <TabPane tab="สินค้าของร้านค้า" key={ProductCreatedBy.ADD}></TabPane>
        {!isFranchise && <TabPane tab="สินค้าที่นำเข้า" key={ProductCreatedBy.IMPORT}></TabPane>}
      </Tabs>
    )
  }

  const ConfirmImportProductModal = (
    <ConfirmImportProduct
      title={`นำเข้าสินค้าด้วยไฟล์ Excel`}
      confirmBtnTxt="ตรวจสอบไฟล์"
      description={`รูปแบบไฟล์ : นามสกุลไฟล์ที่รองรับ คือ .xlsx`}
      isShow={importDailog}
      handleOk={onImportFile}
      handleCancel={() => setImportDailog(false)}
      loading={false}
      key="confirm-import"
      mid={currentUser?.activeMerchant?.id || 0}
      activeMerchantInfo={currentUser}
    />
  )

  const ImportProductFromFileDrawer = (
    <ImportProductFromFile
      visible={importFileDrawer}
      onCloseDrawer={onCloseImportFileDrawer}
      onSuccess={onSuccess}
      productData={productFileData}
      masterData={{
        categories: categories.data,
        manufacturers: manufactuers.data,
        uoms: uoms.data,
      }}
    />
  )

  return (
    <>
      <HomePageLayout
        selected="products"
        title="รายการสินค้า"
        label="รายการผลิตภัณฑ์ สินค้า ที่ร้านของเราจัดจำหน่าย"
        isShowTutorial={showTutorial}
        showTutorial={enableTutorial}
        onClickStart={() => setShowTutorial(true)}
      >
        <Row justify="space-between">
          <Col>{!isSupperAdmin && getTab()}</Col>
          <Col>
            <Space size="middle" wrap={true}>
              {activeTab === ProductCreatedBy.ADD ? (
                <>
                  {!isFranchise && (
                    <PrimaryButton
                      key={ProductCreatedBy.ADD}
                      btnType="Primary"
                      text="เพิ่มสินค้า"
                      icon={<PlusOutlined />}
                      onClick={onClickCreate}
                      className="ttr-add"
                    />
                  )}

                  {!isFranchise && hasImportFileProductPermission && (
                    <PrimaryButton
                      key={ProductCreatedBy.FILE}
                      btnType="Approve"
                      text="นำเข้าสินค้าจากไฟล์ (.xlsx)"
                      icon={<FileExcelFilled />}
                      onClick={onClickImportFile}
                      className="ttr-import"
                    />
                  )}
                </>
              ) : (
                <PrimaryButton
                  key={ProductCreatedBy.IMPORT}
                  text="นำเข้าสินค้า"
                  btnType="Primary"
                  icon={<DownloadOutlined />}
                  onClick={onOpenImportDrawer}
                />
              )}
            </Space>
          </Col>
        </Row>
        {/* {!isSupperAdmin && getTab()} */}
        {content}
        {DetailDrawer}
        {AdjustPriceDrawer}
        {AdjustMaterialDrawer}
        {ConfirmDeleteModal}
        {LoadingModal}
        {ImportDrawer}
        {ConfirmImportProductModal}
        {ImportProductFromFileDrawer}
        {enableTutorial && (
          <AppTutorial
            onCloaseTutorial={() => setShowTutorial(false)}
            showTutorial={showTutorial}
            steps={steps}
          />
        )}
      </HomePageLayout>
    </>
  )
}

const mapStateToProps = (state: RootState) => {
  return {
    currentUser: selectCurrentUser(state),
    dataList: selectList(state),
    listEvent: selectListEvent(state),
    event: selectActionEvent(state),
    categories: selectCateList(state),
    uoms: selectUomList(state),
    manufactuers: selectManufactuerList(state),
    masterMerchant: selectMasterMerchant(state),
    deliveryCost: selectDeliveryDatas(state),
    isPackageC: selectIsPackageC(state),
    isHasPackage: selectIsHasPackageC(state),
    lastProductImport: selectLastProductImport(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

const FilterWrapper = styled.div`
  padding: 10px 0 5px 0;
`

const MyCol = styled(Col)`
  margin-top: 10px;
`

const SearchInput = styled(Input)`
  border-radius: 6px;
  height: 45px;
`
const ThumbImage = styled(Image)`
  border-radius: 5px;
  width: 70px;
  height: 70px;
  object-fit: cover;
`

const StockMin = styled.div`
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.error};
`

const SwitchText = styled.div`
  width: 50px;
`

export default connect(mapStateToProps)(Product)
